// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WebhookLogs_BuscarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /webhook_logs/buscar endpoint
 *
 * Returns a list of webhook logs with decoded payloads for display
 */
import type { WebhookLogs_LogRow } from './WebhookLogs_LogRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface WebhookLogs_BuscarResponseDados {
logs: WebhookLogs_LogRow[]
}

export type WebhookLogs_BuscarResponse = ApiResponse<WebhookLogs_BuscarResponseDados>;

registerResponseContract('WebhookLogs_BuscarResponse', {
  logs: {
    type: 'array',
    required: true,
    items: {
      id:            { type: 'string',  required: true },
      created_at:    { type: 'string',  required: true },
      event_type:    { type: 'string',  required: true },
      provider:      { type: 'string',  required: true },
      status:        { type: 'string',  required: true },
      error_message: { type: 'string',  required: false },
      payload:       { type: 'object',  required: false },
    },
  },
})
